import { api, apiResolve, useApiGet } from '@sierralabs/core-ui';
export function getReport(reportId, params = {}) {
    const request = api.get(`reports/${reportId}`, params);
    const result = apiResolve(request);
    return { request, result };
}
export function useGetReport(reportId) {
    const { data, isLoading, error, get } = useApiGet(`reports/${reportId}`);
    return {
        report: data,
        loadingReport: isLoading,
        loadingReportError: error,
        getReport: get
    };
}
//# sourceMappingURL=useGetReport.js.map